import clsx from "clsx";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { KTIcon } from "../../../helpers";
import { Search } from "../../../partials";
import { HeaderUserMenu } from "../../../partials/layout/header-menus/HeaderUserMenu";
import { useLayout } from "../../core";
import axios from "axios";
import { FetchNotifications } from "../../../../app/modules/auth/core/_requests";
const itemClass = "ms-1 ms-lg-3";
const userAvatarClass = "symbol-35px symbol-md-40px";
const btnIconClass = "fs-1";

const Navbar = () => {
  const { config } = useLayout();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState<any>([]);

  const fetchNotifications = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(FetchNotifications, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }); // Replace with your API endpoint
      setNotifications(response.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markAsSeen = async (id: number) => {

    const token = localStorage.getItem("token");
    const notification = notifications.notifications.find(
      (notification: any) => notification.id === id
    );
    const link = notification ? notification.link : "#";
    const seen = `${process.env.REACT_APP_API_URL}/api/admin/notifications/${id}/seen`;
    try {
      await axios.put(
        `${seen}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleClosePopup();
      fetchNotifications();
      navigate(link);

    } catch (error) {
      console.error("Error marking notification as seen:", error);
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    // 👇 Call it once immediately
    fetchNotifications();
  
    // 👇 Then repeat every 10 minutes (600,000ms)
    const intervalId = setInterval(() => {
      fetchNotifications();
    }, 600000);
  
    // 🧹 Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="app-navbar flex-shrink-0">
      <div className={clsx("app-navbar-item align-items-stretch", itemClass)}>
        <Search />
      </div>

      <div className={clsx("app-navbar-item", itemClass)}>
        <div
          className="position-relative cursor-pointer"
          onClick={() => setIsPopupOpen(!isPopupOpen)}
        >
          <KTIcon iconName="notification-bing" className={btnIconClass} />
          {notifications.count > 0 && (
            <span className="badge badge-circle badge-danger position-absolute top-0 start-100 translate-middle">
              {notifications.count > 0 ? notifications.count : ""}
            </span>
          )}
        </div>
        <>
          {/* Overlay */}
          {isPopupOpen && (
            <div
              className="position-fixed w-100 h-100"
              style={{
                top: 0,
                left: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1049,
              }}
              onClick={handleClosePopup}
            ></div>
          )}

          {/* Sidebar */}
          <div
            className="position-fixed bg-white shadow rounded "
            style={{
              top: 0,
              right: 0,
              padding: isPopupOpen ? "20px" : "0",
              height: "100%",
              width: "100%",
              maxWidth: isPopupOpen ? "400px" : "0",
              zIndex: 1050,
              overflowY: "auto",
              transition: "all 0.3s ease-in-out",
            }}
          >
            {isPopupOpen && (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                  <h5 className="mb-0">Notifications</h5>
                  <button
                    className="btn btn-sm btn-light"
                    onClick={handleClosePopup}
                    style={{ fontSize: "14px" }}
                  >
                    Close
                  </button>
                </div>
                <div className="notification-list">
                  {notifications.notifications && notifications.notifications.length > 0 ? (
                    notifications.notifications.map((notification: any) => (
                      <div
                        key={notification.id}
                        className="notification-item d-flex align-items-start p-3 mb-2 bg-light rounded"
                        style={{ cursor: "pointer" }}
                        onClick={() => markAsSeen(notification.id)}
                      >
                        <div className="icon me-3">
                          <KTIcon iconName="notification-bing" className="fs-2 text-primary" />
                        </div>
                        <div className="content">
                          <strong className="d-block">{notification.title}</strong>
                          <span className="text-muted small">{notification.message}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-5">
                      <KTIcon iconName="notification-bing" className="fs-1 mb-3" />
                      <p className="mb-0">No notifications</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      </div>

      <div className={clsx("app-navbar-item", itemClass)}>
        <div
          className={clsx("cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
        >
          <i className="ki-duotone ki-bi bi-person-fill fs-1"></i>
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div
          className="app-navbar-item d-lg-none ms-2 me-n3"
          title="Show header menu"
        >
          <div
            className="btn btn-icon btn-active-color-primary w-35px h-35px"
            id="kt_app_header_menu_toggle"
          >
            <KTIcon iconName="text-align-left" className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  );
};

export { Navbar };
